<div class="card">
  <div class="card-header">
    <h4 class="card-title">{{ 'MENU.DASHBOARD.add_vision_ksa' | translate }}</h4>
  </div>
  <div class="card-body">
    <p class="card-text">{{ 'MENU.DASHBOARD.add_vision_ksa_list' | translate }}</p>
  </div>
</div>

<div class="card">
  <div class="card-body">
    <form #visionForm="ngForm" (ngSubmit)="onSubmit()" enctype="multipart/form-data">
      <div class="row">

        <!-- 🖼️ Logo Upload -->
        <div class="col-3">
          <div class="form-group">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.partner_logo' | translate }}</label>
           
            <!-- منطقة رفع الملف -->
            <div class="file-upload-container">
              <input type="file" id="logoUpload" accept="image/*" (change)="onFileSelected($event)" #fileInput>
              <div class="file-upload-label">
                <i class="fas fa-cloud-upload-alt file-upload-icon" style="color: #cca44c;"></i>
                <div class="file-upload-text">{{ 'MENU.DASHBOARD.click_to_upload_logo' | translate }}</div>
                <div class="file-upload-text"> {{ 'MENU.DASHBOARD.drag_drop_image' | translate }}</div>
                <div class="form-hint">{{ 'MENU.DASHBOARD.recommended_size' | translate }}</div>
              </div>
            </div>

            <!-- معاينة الصورة الحالية -->
            <div class="preview-container" *ngIf="showCurrentIcon">
              <div class="preview-header">
                <span class="preview-title">{{ 'MENU.DASHBOARD.current_logo' | translate }}</span>
              </div>
              <img [src]="formData.icon" class="logo-preview" alt="Current Logo">
              <div class="preview-actions mt-2">
                <button type="button" class="btn btn-outline btn-sm" (click)="removeCurrentLogo()">
                  <i class="fas fa-trash me-1"></i> {{ 'MENU.DASHBOARD.remove_current' | translate }}
                </button>
              </div>
            </div>

            <!-- معاينة الصورة الجديدة المختارة -->
            <div class="preview-container" *ngIf="previewUrl">
              <div class="preview-header">
                <span class="preview-title">{{ 'MENU.DASHBOARD.new_logo_preview' | translate }}</span>
              </div>
              <img [src]="previewUrl" class="logo-preview" alt="New Logo Preview">
            </div>
            
            <!-- رسالة إذا مافيش صورة -->
            <div class="no-preview" *ngIf="!showCurrentIcon && !previewUrl">
              <div class="no-preview-content">
                <i class="fas fa-image no-preview-icon"></i>
                <div class="form-hint"> {{ 'MENU.DASHBOARD.no_logo_uploaded' | translate }}</div>
              </div>
            </div>
          </div>
        </div>

       

      </div>
      <div class="row">
         <!-- 📝 Title Arabic -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.title_ar' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.title_ar"
              name="title_ar"
              #titleAr="ngModel"
              required
              [class.is-invalid]="titleAr.invalid && titleAr.touched"
              dir="rtl"
              placeholder="{{ 'MENU.DASHBOARD.enter_title_ar' | translate }}"
            />
            <div *ngIf="titleAr.invalid && titleAr.touched" class="text-danger small mt-1">
              {{ 'MENU.DASHBOARD.title_required' | translate }}
            </div>
          </div>
        </div>

        <!-- 📝 Title English -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.title_en' | translate }}</label>
            <input
              type="text"
              class="form-control"
              [(ngModel)]="formData.title_en"
              name="title_en"
              #titleEn="ngModel"
              required
              [class.is-invalid]="titleEn.invalid && titleEn.touched"
              dir="ltr"
              placeholder="{{ 'MENU.DASHBOARD.enter_title_en' | translate }}"
            />
            <div *ngIf="titleEn.invalid && titleEn.touched" class="text-danger small mt-1">
              {{ 'MENU.DASHBOARD.title_required' | translate }}
            </div>
          </div>
        </div>

        <!-- 📝 Description Arabic -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.description_ar' | translate }}</label>
            <textarea
              class="form-control"
              rows="4"
              [(ngModel)]="formData.description_ar"
              name="description_ar"
              #descAr="ngModel"
              required
              [class.is-invalid]="descAr.invalid && descAr.touched"
              dir="rtl"
              placeholder="{{ 'MENU.DASHBOARD.enter_description_ar' | translate }}"
            ></textarea>
            <div *ngIf="descAr.invalid && descAr.touched" class="text-danger small mt-1">
              {{ 'MENU.DASHBOARD.description_required' | translate }}
            </div>
          </div>
        </div>

        <!-- 📝 Description English -->
        <div class="col-md-6">
          <div class="mb-3">
            <label class="form-label required-field">{{ 'MENU.DASHBOARD.description_en' | translate }}</label>
            <textarea
              class="form-control"
              rows="4"
              [(ngModel)]="formData.description_en"
              name="description_en"
              #descEn="ngModel"
              required
              [class.is-invalid]="descEn.invalid && descEn.touched"
              dir="ltr"
              placeholder="{{ 'MENU.DASHBOARD.enter_description_en' | translate }}"
            ></textarea>
            <div *ngIf="descEn.invalid && descEn.touched" class="text-danger small mt-1">
              {{ 'MENU.DASHBOARD.description_required' | translate }}
            </div>
          </div>
        </div>
      </div>

      <!-- 💾 Submit -->
      <div class="row">
        <div class="col-sm-4">
          <div class="mb-3 d-flex justify-content-start">
            <button
              type="submit"
              class="btn"
              [disabled]="visionForm.invalid"
              style="background-color: #cca44c !important; color: #fff;"
            >
              {{ 'MENU.DASHBOARD.add' | translate }}
            </button>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>